let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1rHns")).then(() => parcelRequire('2h9yT'));